import { CloseOutlined, InfoCircleOutlined, SettingOutlined } from '@ant-design/icons'
import {
  Modal,
  Row,
  Button,
} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import styles from './diagnosis/Diagnosis.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { CopySettingModal } from './CopySettingModal'
import { selectSettings } from '../user/setting/settingSlice'
import { Checks } from '../../models/setting'

export const CopyModal = (props: {
  visible?: any
  mlBtnLoading: boolean
  cfBtnLoading: boolean
  kcBtnLoading: boolean
  onCancel: () => void
  useML: () => void
  useCF: () => void
  useKC: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const settings = useSelector(selectSettings)

  const [isSettingVisible, setIsSettingVisible] = useState(false)
  
  // 获取复制处方价格设置
  const fzcfjgSetting = settings?.[Checks.FZCFJG]
  const fzcfjgOptions = fzcfjgSetting ? fzcfjgSetting.split(',') : ['1', '2', '3']
  
  // 根据设置决定显示哪些按钮
  const showML = fzcfjgOptions.includes('1')
  const showCF = fzcfjgOptions.includes('2')
  const showKC = fzcfjgOptions.includes('3')

  return (
    <>
      <Modal
        visible={props.visible}
        footer={null}
        destroyOnClose
        className={styles.modal}
      >
        <div
          style={{
            padding: '32px',
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <InfoCircleOutlined
            style={{
              color: '#faad14',
              marginRight: '10px',
              fontSize: '22px',
            }}
          />
          <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
            是否从处方复制价格？
          </span>
        </div>
        <CloseOutlined
          style={{
            position: 'absolute',
            color: '#8c8c8c',
            right: 10,
            top: 20,
            marginRight: '10px',
            fontSize: '22px',
          }}
          onClick={() => {
            props.onCancel()
          }}
        />
        <Row
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px',
            position: 'relative',
          }}
        >
          <SettingOutlined
            style={{
              position: 'absolute',
              bottom: 5, left: 0,
              fontSize: '20px',
              color: '#999999'
            }}
            onClick={(() => {
              setIsSettingVisible(true)
            })}></SettingOutlined>
          {showML && (
            <Button
              style={{
                marginRight: '14px',
                borderColor: '#027AFF',
                color: '#027AFF',
                backgroundColor: 'transparent',
              }}
              loading={props.mlBtnLoading}
              onClick={() => {
                props.useML()
              }}
            >
              使用目录价格
            </Button>
          )}
          {showCF && (
            <Button
              style={{
                marginRight: '14px',
                borderColor: '#027AFF',
                color: '#027AFF',
                backgroundColor: 'transparent',
              }}
              loading={props.cfBtnLoading}
              onClick={() => {
                props.useCF()
              }}
            >
              使用处方价格
            </Button>
          )}
          {showKC && (
            <Button
              style={{
                marginRight: '14px',
                borderColor: '#027AFF',
                color: '#027AFF',
                backgroundColor: 'transparent',
              }}
              loading={props.kcBtnLoading}
              onClick={() => {
                props.useKC()
              }}
            >
              使用库存价格
            </Button>
          )}
        </Row>
      </Modal>
      <CopySettingModal
        visible={isSettingVisible}
        onCancel={(() => {
          setIsSettingVisible(false)
        })}
        onOk={(() => {
          setIsSettingVisible(false)
        })}
      />
    </>
  )
}
